import { isEmptyObject } from 'helpers/object';

export const filterCampaigns = (campaigns, filters) => {
  const filteredCampaigns = campaigns.filter(item => {
    let campaignTypeCondition = true;
    let vehicleTypeCondition = true;
    let ecoCondition = true;
    if (filters.campaignType !== null) {
      campaignTypeCondition = filters.campaignType.includes(item.campaignType);
    }
    if (filters.vehicleTypeFilterValue && filters.vehicleTypeFilterValue !== 'none') {
      vehicleTypeCondition = filters.vehicleTypeFilterValue.includes(
        item.campaignDetail.vehicleType
      );
    }

    if (filters.eco === true) {
      ecoCondition = item.car && item.car.wltpLabel && item.car.wltpLabel === 'ECO';
    }
    return campaignTypeCondition && vehicleTypeCondition && ecoCondition;
  });
  return filteredCampaigns;
};

export const getCountCampaignsByCampaignType = (campaigns, filter) => {
  const filteredCampaigns = campaigns.filter(item => {
    if (filter !== null) {
      return filter.includes(item.campaignType);
    }
    return true;
  });
  return filteredCampaigns.length.toString();
};

export const getCountCampaignsByEco = campaigns => {
  const filteredCampaigns = campaigns.filter(
    item => item.car && item.car.wltpLabel && item.car.wltpLabel === 'ECO'
  );
  return filteredCampaigns.length.toString();
};

export const getQueryFilters = filters => {
  if (!filters || isEmptyObject(filters)) return '';
  let query = '';
  // eslint-disable-next-line complexity
  Object.entries(filters).forEach(filter => {
    if (
      Array.isArray(filter[1].value) &&
      filter[1].dataType === 'Range' &&
      filter[1].value.length
    ) {
      const queryFilter = filter[1].query
        .replace('#value1#', filter[1].value[0])
        .replace('#value2#', filter[1].value[1]);
      query = query.concat(`&${queryFilter}`);
    }
    if (
      Array.isArray(filter[1].value) &&
      filter[1].dataType === 'Array' &&
      filter[1].value.length
    ) {
      if (!filter[1].value.includes('TODOS')) {
        const queryFilter = filter[1].query.replace('#values#', filter[1].value);
        query = query.concat(`&${queryFilter}`);
      }
    }
    if (typeof filter[1].value === 'string' && filter[1].value) {
      const queryFilter = filter[1].query.replace('#value#', filter[1].value);
      query = query.concat(`&${queryFilter}`);
    }
  });
  return query;
};
